<template>
  <div>
    <el-dialog title="岗位选择" :visible.sync="showPostApply" width="85%" :before-close="handleClose">
      <el-table :data="postApplyData" border>
        <el-table-column fixed label="操作" column-key="id" align="center" width="70px">
          <template slot-scope="scope">
            <el-radio :disabled="signupInfo.status == 1 || scope.row.filled == 1" :label="scope.row.id" v-model="signupInfo.postId" @change="choosePost(scope.row)">
              <br /><span v-if="scope.row.filled == 1">已招满</span></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="招聘单位" width="150" align="center" />
        <el-table-column prop="subsidiary" label="部门/子公司" width="150" align="center" />
        <el-table-column prop="name" label="岗位名称" width="150" align="center" />
        <el-table-column prop="code" label="岗位代码" width="150" align="center" />
        <el-table-column prop="majorCategory" label="专业类别" width="150" align="center" show-overflow-tooltip />
        <el-table-column prop="majorDemand" label="专业要求" width="150" align="center" show-overflow-tooltip />
        <el-table-column prop="education" label="学历要求" width="150" align="center" show-overflow-tooltip />
        <el-table-column prop="workExperience" label="工作经验要求" align="center" show-overflow-tooltip />
      </el-table>
      <div class="mybtns" v-if="noticeInfo.sendResume == 0">
        <button class="step2 default-btn next-step" @click="nextStep('two')">
          {{
          signupInfo.status && signupInfo.status != 3
          ? "查看报名信息"
          : "填写报名信息"
          }}
        </button>
      </div>
      <div class="mybtns" v-if="noticeInfo.sendResume == 1">
        <button class="step2 default-btn next-step" @click="nextStep('two')">
          {{
          signupInfo.status && signupInfo.status != 3
          ? "查看简历信息"
          : "填写简历信息"
          }}
        </button>
      </div>
    </el-dialog>
    <!-- 个人信息登记表 -->
    <el-dialog title="个人信息登记表" :visible.sync="applyMessage" width="90%" :before-close="handleCloseUserMessage" :fullscreen="true">
      <el-form class="custom-form" ref="signForm" :model="signForm" :disabled="disabled">
        <el-row class="all-border">
          <el-col :span="24">
            <!-- 基本信息&相册 -->
            <el-row>
              <el-row class="base-user-message">
                <!-- 左侧基本信息 -->
                <el-col :span="20">
                  <el-row>
                    <el-col :span="6" class="form-col-left">
                      <el-form-item label="姓名" class="form-label">
                        <el-input v-model="signupInfo.name" disabled class="form-input-two" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" class="form-col">
                      <el-form-item label="姓别" class="form-label">
                        <el-select v-model="signupInfo.gender" disabled class="form-input-two">
                          <el-option :value="1" label="男" />
                          <el-option :value="2" label="女" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" class="form-col">
                      <el-form-item label="出生年月" class="form-label">
                        <el-input v-model="signupInfo.birthday" disabled class="form-input" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" class="form-col">
                      <el-form-item label="出生地" class="form-label">
                        <el-input v-model="signupInfo.birthAddress" placeholder="请输入出生地" class="form-input-birthplace" clearable />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6" class="form-col-left">
                      <el-form-item label="民族" class="form-label">
                        <el-select v-model="signupInfo.nation" class="form-input-two" filterable placeholder="请选择民族" clearable>
                          <el-option v-for="item in nationList" :key="item.label" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" class="form-col">
                      <el-form-item label="政治面貌" class="form-label">
                        <el-select v-model="signupInfo.political" class="form-input" clearable placeholder="请选择政治面貌">
                          <el-option value="群众" />
                          <el-option value="共青团员" />
                          <el-option value="预备党员" />
                          <el-option value="中共党员" />
                          <el-option value="其他" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" class="form-col">
                      <el-form-item label="婚否" class="form-label">
                        <el-select v-model="signupInfo.isMarry" class="form-input" clearable placeholder="请选择是否婚否">
                          <el-option value="已婚" />
                          <el-option value="未婚" />
                          <el-option value="离异" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" class="form-col">
                      <el-form-item label="健康状况" class="form-label">
                        <el-select v-model="signupInfo.health" class="form-input" clearable placeholder="请选择健康状况">
                          <el-option value="健康" />
                          <el-option value="良好" />
                          <el-option value="其他" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6" class="form-col-left">
                      <el-form-item label="联系电话" class="form-label">
                        <el-input v-model="signupInfo.telephone" disabled class="form-input" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="form-col">
                      <el-form-item label="身份证号" class="form-label">
                        <el-input v-model="signupInfo.cardNum" disabled class="form-input" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10" class="form-col">
                      <el-form-item label="电子邮箱" class="form-label">
                        <el-input v-model="signupInfo.email" disabled class="form-input" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="form-col-left">
                      <el-row>
                        <el-col :span="12">
<!--                          <el-form-item label="籍贯" class="form-label">-->
                          <el-form-item label="户籍地" class="form-label">
                            <el-cascader class="form-input-native-place" placeholder="请选择户籍地" :options="nativePlaceOptions" :props="treeSelect" filterable clearable v-model="signupInfo.nativePlace" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <el-input v-model="signupInfo.nativeAddress" placeholder="请输入详细地址" clearable class="input-detailed-address" />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="12" class="form-col-right">
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="现住址" class="form-label">
                            <el-cascader class="form-input-native-place" placeholder="请选择现住址" :options="presentAddressOptions" :props="treeSelect" filterable clearable v-model="signupInfo.current" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <el-input v-model="signupInfo.currentAddress" placeholder="请输入详细地址" clearable class="input-detailed-address" />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
                <!-- 右侧用户照片 -->
                <el-col :span="4" class="form-col-img">
                  <img :src="signupInfo.headUrl" class="user-img" height="257x" />
                </el-col>
              </el-row>
            </el-row>
            <!-- 参加工作时间 -->
            <el-row>
              <el-col :span="8" class="form-col">
                <el-form-item label="参加工作时间" class="form-label">
                  <el-date-picker class="form-input-unit" v-model="signupInfo.workTime" type="date" placeholder="请选择日期" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="form-col">
                <el-form-item label="现工作单位" class="form-label">
                  <el-input v-model="signupInfo.workCompany" class="form-input-unit" clearable placeholder="清输入现工作单位" />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="form-col-right">
                <el-form-item label="现工作部门级岗位" class="form-label">
                  <el-input v-model="signupInfo.workDeptPost" class="form-input-post" clearable placeholder="请输入现工作部门及岗位" />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 应聘单位 -->
            <el-row>
              <el-col :span="8" class="form-col">
                <el-form-item label="应聘单位" class="form-label">
                  <el-input v-model="signupInfo.companyName" disabled clearable class="form-input-employer" />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="form-col">
                <el-form-item label="应聘岗位序列号" class="form-label">
                  <el-input v-model="signupInfo.postNum" disabled clearable class="form-input-serial-number" />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="form-col-right">
                <el-form-item label="应聘岗位名" class="form-label">
                  <el-input v-model="signupInfo.postName" disabled clearable class="form-input-post-name" />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 温馨提示 -->
            <el-row>
              <el-col :span="24">
                <span class="form-col-hint">
                  <p>温馨提示：全日制学历如不涉及对应阶段,起止时间任选,院校专业填"无",否则无法提交报名。</p>
                </span>
              </el-col>
            </el-row>
            <!-- 选择教育情况 -->
            <el-row>
              <el-col :span="12" class="form-select-educationType">
                <el-form-item label="请选择是否全日制教育" class="form-label">
                  <el-select v-model="signupInfo.educationType" clearable class="form-select-educationType-type" placeholder="请选择是否全日制教育">
                    <el-option :value="1" label="全日制" />
                    <el-option :value="2" label="非全日制" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="form-select-max-educationType">
                <el-form-item label="请选择最高学历" class="form-label">
                  <el-select v-model="signupInfo.degree" clearable class="form-select-max-educationType-type" placeholder="请选择最高学历">
                    <el-option v-for="(item,index) in degreeList" :key="index" :value="item.value" :label="item.name" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 学历分类 -->
            <el-row class="education" v-if="signupInfo.educationType && signupInfo.degree">
              <el-col :span="2" class="education-classify-left">学位</el-col>
              <el-col :span="6" class="education-classify">起止时间</el-col>
              <el-col :span="5" class="education-classify">院校（具体到院系）</el-col>
              <el-col :span="5" class="education-classify">专业</el-col>
              <el-col :span="3" class="education-classify">学历</el-col>
              <el-col :span="3" class="education-classify">院校类别</el-col>
            </el-row>
            <!-- 全日制 -->
            <el-row>
              <el-col :span="24">
                <!-- 全日制博士 -->
                <el-row class="full-time" v-if="signupInfo.educationType == 1 && signupInfo.degree == 6">
                  <el-col :span="2" class="education-classify-left">博士</el-col>
                  <el-col :span="6" class="full-time-message-date">
                    <el-form-item>
                      <el-date-picker v-model="zgEducation.startEndTime" unlink-panels type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" class="full-time-message-data" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="zgEducation.college" placeholder="请输入院校(具体到院系)" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="zgEducation.major" placeholder="请输入专业" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item class="form-label">
                      <el-select v-model="zgEducation.degree" clearable class="full-time-message-department" placeholder="请选择最高学历">
                        <el-option v-for="(item,index) in degreeList" :key="index" :value="item.value" :label="item.name" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item>
                      <el-select v-model="zgEducation.schoolFeature" clearable class="full-time-message-department" placeholder="请选择院校类别">
                        <el-option v-for="(item,index) in schoolFeatureList" :key="index" :value="item.id" :label="item.label" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 全日制研究生 -->
                <el-row class="full-time" v-if="signupInfo.educationType == 1 && (signupInfo.degree == 6||signupInfo.degree == 5)">
                  <el-col :span="2" class="education-classify-left">研究生</el-col>
                  <el-col :span="6" class="full-time-message-date">
                    <el-form-item>
                      <el-date-picker v-model="yjsEducation.startEndTime" unlink-panels type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" class="full-time-message-data" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="yjsEducation.college" placeholder="请输入院校(具体到院系)" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="yjsEducation.major" placeholder="请输入专业" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item class="form-label">
                      <el-select v-model="yjsEducation.degree" clearable class="full-time-message-department" placeholder="请选择最高学历">
                        <el-option v-for="(item,index) in degreeList" :key="index" :value="item.value" :label="item.name" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item>
                      <el-select v-model="yjsEducation.schoolFeature" clearable class="full-time-message-department" placeholder="请选择院校类别">
                        <el-option v-for="(item,index) in schoolFeatureList" :key="index" :value="item.id" :label="item.label" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 全日制本科 -->
                <el-row class="full-time" v-if="signupInfo.educationType == 1 && (signupInfo.degree == 6||signupInfo.degree == 5||signupInfo.degree == 4)">
                  <el-col :span="2" class="education-classify-left">本科</el-col>
                  <el-col :span="6" class="full-time-message-date">
                    <el-form-item>
                      <el-date-picker v-model="fullEducation.startEndTime" unlink-panels type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" class="full-time-message-data" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="fullEducation.college" placeholder="请输入院校(具体到院系)" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="fullEducation.major" placeholder="请输入专业" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item class="form-label">
                      <el-select v-model="fullEducation.degree" clearable class="full-time-message-department" placeholder="请选择最高学历">
                        <el-option v-for="(item,index) in degreeList" :key="index" :value="item.value" :label="item.name" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item>
                      <el-select v-model="fullEducation.schoolFeature" clearable class="full-time-message-department" placeholder="请选择院校类别">
                        <el-option v-for="(item,index) in schoolFeatureList" :key="index" :value="item.id" :label="item.label" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 全日制专科及以下 -->
                <el-row class="full-time"
                        v-if="signupInfo.educationType == 1 && (signupInfo.degree == 6||signupInfo.degree == 5||signupInfo.degree == 4||signupInfo.degree == 3||signupInfo.degree == 2||signupInfo.degree == 1)">
                  <el-col :span="2" class="education-classify-left">专科及以下</el-col>
                  <el-col :span="6" class="full-time-message-date">
                    <el-form-item>
                      <el-date-picker v-model="zkEducation.startEndTime" unlink-panels type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" class="full-time-message-data" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="zkEducation.college" placeholder="请输入院校(具体到院系)" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="zkEducation.major" placeholder="请输入专业" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item class="form-label">
                      <el-select v-model="zkEducation.degree" clearable class="full-time-message-department" placeholder="请选择最高学历">
                        <el-option v-for="(item,index) in degreeList" :key="index" :value="item.value" :label="item.name" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item>
                      <el-select v-model="zkEducation.schoolFeature" clearable class="full-time-message-department" placeholder="请选择院校类别">
                        <el-option v-for="(item,index) in schoolFeatureList" :key="index" :value="item.id" :label="item.label" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <!-- 非全日制 -->
            <el-row>
              <el-col :span="24">
                <!-- 非全日制博士 -->
                <el-row class="full-time" v-if="signupInfo.educationType == 2 && signupInfo.degree == 6">
                  <el-col :span="2" class="education-classify-left">博士</el-col>
                  <el-col :span="6" class="full-time-message-date">
                    <el-form-item>
                      <el-date-picker v-model="partEducation.startEndTime" unlink-panels type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" class="full-time-message-data" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="partEducation.college" placeholder="请输入院校(具体到院系)" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="partEducation.major" placeholder="请输入专业" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item class="form-label">
                      <el-select v-model="partEducation.degree" clearable class="full-time-message-department" placeholder="请选择最高学历">
                        <el-option v-for="(item,index) in degreeList" :key="index" :value="item.value" :label="item.name" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item>
                      <el-select v-model="partEducation.schoolFeature" clearable class="full-time-message-department" placeholder="请选择院校类别">
                        <el-option v-for="(item,index) in schoolFeatureList" :key="index" :value="item.id" :label="item.label" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 非全日制研究生 -->
                <el-row class="full-time" v-if="signupInfo.educationType == 2 && (signupInfo.degree == 6||signupInfo.degree == 5)">
                  <el-col :span="2" class="education-classify-left">研究生</el-col>
                  <el-col :span="6" class="full-time-message-date">
                    <el-form-item>
                      <el-date-picker v-model="partEducation.startEndTime" unlink-panels type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" class="full-time-message-data" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="partEducation.college" placeholder="请输入院校(具体到院系)" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="partEducation.major" placeholder="请输入专业" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item class="form-label">
                      <el-select v-model="partEducation.degree" clearable class="full-time-message-department" placeholder="请选择最高学历">
                        <el-option v-for="(item,index) in degreeList" :key="index" :value="item.value" :label="item.name" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item>
                      <el-select v-model="partEducation.schoolFeature" clearable class="full-time-message-department" placeholder="请选择院校类别">
                        <el-option v-for="(item,index) in schoolFeatureList" :key="index" :value="item.id" :label="item.label" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 非全日制本科 -->
                <el-row class="full-time" v-if="signupInfo.educationType == 2 && (signupInfo.degree == 6||signupInfo.degree == 5||signupInfo.degree == 4)">
                  <el-col :span="2" class="education-classify-left">本科</el-col>
                  <el-col :span="6" class="full-time-message-date">
                    <el-form-item>
                      <el-date-picker v-model="partEducation.startEndTime" unlink-panels type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" class="full-time-message-data" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="partEducation.college" placeholder="请输入院校(具体到院系)" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="partEducation.major" placeholder="请输入专业" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item class="form-label">
                      <el-select v-model="partEducation.degree" clearable class="full-time-message-department" placeholder="请选择最高学历">
                        <el-option v-for="(item,index) in degreeList" :key="index" :value="item.value" :label="item.name" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item>
                      <el-select v-model="partEducation.schoolFeature" clearable class="full-time-message-department" placeholder="请选择院校类别">
                        <el-option v-for="(item,index) in schoolFeatureList" :key="index" :value="item.id" :label="item.label" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 非全日制专科及以下 -->
                <el-row class="full-time"
                        v-if="signupInfo.educationType == 2 && (signupInfo.degree == 6||signupInfo.degree == 5||signupInfo.degree == 4||signupInfo.degree == 3||signupInfo.degree == 2||signupInfo.degree == 1)">
                  <el-col :span="2" class="education-classify-left">专科及以下</el-col>
                  <el-col :span="6" class="full-time-message-date">
                    <el-form-item>
                      <el-date-picker v-model="partEducation.startEndTime" unlink-panels type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" class="full-time-message-data" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="partEducation.college" placeholder="请输入院校(具体到院系)" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="full-time-message">
                    <el-form-item>
                      <el-input v-model="partEducation.major" placeholder="请输入专业" class="full-time-message-department" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item class="form-label">
                      <el-select v-model="partEducation.degree" clearable class="full-time-message-department" placeholder="请选择最高学历">
                        <el-option v-for="(item,index) in degreeList" :key="index" :value="item.value" :label="item.name" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" class="full-time-message">
                    <el-form-item>
                      <el-select v-model="partEducation.schoolFeature" clearable class="full-time-message-department" placeholder="请选择院校类别">
                        <el-option v-for="(item,index) in schoolFeatureList" :key="index" :value="item.id" :label="item.label" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <!-- 工作经历 -->
            <el-row>
              <el-col :span="24">
                <el-row class="form-row-work-experience">
                  <p>工作经历（按时间先后顺序填写）</p>
                </el-row>
                <el-row class="education">
                  <el-col :span="6" class="work-experience-left">起止时间</el-col>
                  <el-col :span="6" class="work-experience-left">单位及部门</el-col>
                  <el-col :span="5" class="work-experience-left">岗位及职务</el-col>
                  <el-col :span="6" class="work-experience-right">主要工作职责</el-col>
                  <el-col :span="1" class="work-experience-right"></el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-row v-for="(item,index) in workExperienceList" :key="index">
                  <div>
                    <el-col :span="6" class="work-experience-col-date">
                      <el-form-item>
                        <el-date-picker v-model="item.startEndTime" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels
                                        class="work-experience-col-data" @change="onTimeChange($event, index)"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" class="work-experience-col">
                      <el-form-item>
                        <el-input v-model="item.uintDept" placeholder="请输入单位及部门" clearable class="work-experience-col-input" @change="onDeptChange($event, index)" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="5" class="work-experience-col">
                      <el-form-item>
                        <el-input v-model="item.post" placeholder="请输入岗位及职务" clearable class="work-experience-col-input" @change="onPostChange($event, index)" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" class="work-experience-col-right">
                      <el-form-item>
                        <el-input v-model="item.duty" type="textarea" :rows="2" placeholder="请输入主要工作职责" clearable class="work-experience-col-textarea" @change="onDutyChange($event, index)" />
                      </el-form-item>
                    </el-col>
                    <el-col v-if="index >= 4" :span="1" class="work-experience-col-right">
                      <el-form-item>
                        <el-button class="work-experience-col-but"
                          size="small"
                          icon="el-icon-minus"
                          v-if="index >= 4"
                          @click="redAns(index)"
                        ></el-button>
                      </el-form-item>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-row class="form-row-work">
                  <div v-for="(item,index) in workExperienceList" :key="index">
                    <el-col v-if="index == workExperienceList.length - 1">
                      <el-button
                        size="small"
                        icon="el-icon-plus"
                        @click="addAns()"
                      ></el-button>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
            </el-row>
            <!-- 获得奖励情况 -->
            <el-row class="form-row-award">
              <el-col :span="3" class="form-row-award-left">
                <el-form-item label="获得奖励情况" />
              </el-col>
              <el-col :span="21" class="form-row-award-rigth">
                <el-form-item>
                  <el-input type="textarea" :rows="3" v-model="signupInfo.rewards" placeholder="请输入获得奖励的情况" />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 相关资格证书（专业技术资格、职（执）业资格等） -->
            <el-row>
              <el-row>
                <el-col :span="24">
                  <el-row class="form-row-certificate">
                    <P>相关资格证书（专业技术资格、职（执）业资格等）</P>
                  </el-row>
                  <el-row class="education">
                    <el-col :span="6" class="certificate-message-title-left">名称</el-col>
                    <el-col :span="6" class="certificate-message-title">等级</el-col>
                    <el-col :span="6" class="certificate-message-title">获得时间</el-col>
                    <el-col :span="6" class="certificate-message-title">颁发机构</el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row v-for="(item,index) in certificateList" :key="index">
                <el-col :span="6" class="certificate-col">
                  <el-input class="certificate-col-input" v-model="item.name" placeholder="请输入证书名称" clearable @change="onNameChange($event, index)" />
                </el-col>
                <el-col :span="6" class="certificate-col">
                  <el-input class="certificate-col-input" v-model="item.grade" placeholder="请输入证书等级" clearable @change="onGradeChange($event, index)" />
                </el-col>
                <el-col :span="6" class="certificate-col">
                  <el-date-picker class="certificate-col-input" v-model="item.getTime" type="date" placeholder="请选择获得日期" @change="onGetTimeChange($event, index)" />
                </el-col>
                <el-col :span="6" class="certificate-col-right">
                  <el-input class="certificate-col-input" v-model="item.organization" placeholder="请输入颁发机构" clearable @change="onOrganizationChange($event, index)" />
                </el-col>
              </el-row>
            </el-row>
            <!-- 其他需说明的情况 -->
            <el-row class="form-row-else">
              <el-col :span="3" class="form-row-award-left">
                <el-form-item label="其他需说明的情况"></el-form-item>
              </el-col>
              <el-col :span="21" class="form-row-award-rigth">
                <el-form-item>
                  <el-input type="textarea" :rows="3" v-model="signupInfo.remark" placeholder="请输入其他需说明的情况" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nextStep('one')" v-if="signupInfo.status < 2 || signupInfo.status == 3">上一步</el-button>
        <el-button @click="zancun('zancun')">暂 存</el-button>
        <el-button type="primary" @click="messageConfirm('tijiao')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 信息确认框 -->
    <el-dialog title="信息确认" :visible.sync="messageDialog" width="50%" :before-close="handleCloseMessageDialog">
      <el-form :model="userMessageConfirmForm" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名">
              <el-input v-model="userMessageConfirmForm.name" disabled placeholder="请输入用户名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="userMessageConfirmForm.phone" disabled placeholder="请输入联系方式" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号">
              <el-input v-model="userMessageConfirmForm.cardNumber" disabled placeholder="请输入身份证号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱">
              <el-input v-model="userMessageConfirmForm.email" disabled placeholder="请输入邮箱" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="应聘单位">
              <el-input v-model="userMessageConfirmForm.positionApplied" disabled placeholder="请输入应聘单位" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应聘岗位">
              <el-input v-model="userMessageConfirmForm.positionJob" disabled placeholder="请输入应聘岗位" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userMessageCancel">取 消</el-button>
        <el-button type="primary" @click="userMessageConfirm('tijiao')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import request from "@/request";
  import { re } from "semver";

  export default {
    name: "PostApply",
    props: {
      recruitId: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        showPostApply: false,
        postApplyData: [],
        post: {
          noticeId: "",
        },
        signupInfo: {
          status: 0,
        },
        noticeInfo: {},
        currentRow: {},
        applyMessage: false,
        // 籍贯
        nativePlaceOptions: [],
        // 现住址
        presentAddressOptions: [],
        treeSelect: {
          label: "areaName",
          value: "areaName",
          level: "level",
        },
        signForm: {},
        disabled: false,
        nationList: [],
        schoolFeatureList: [],
        // 职业证书
        certificateList: [
          {id: 1, name: "", grade: "", getTime: "", organization: ""},
          {id: 2, name: "", grade: "", getTime: "", organization: ""},
          {id: 3, name: "", grade: "", getTime: "", organization: ""},
          {id: 4, name: "", grade: "", getTime: "", organization: ""},
        ],
        workExperienceList: [
          {id: 1, startEndTime: "", startTime: null, endTime: null, uintDept: "", post: "", duty: "",},
          {id: 2, startEndTime: "", startTime: null, endTime: null, uintDept: "", post: "", duty: "",},
          {id: 3, startEndTime: "", startTime: null, endTime: null, uintDept: "", post: "", duty: "",},
          {id: 4, startEndTime: "", startTime: null, endTime: null, uintDept: "", post: "", duty: "",},
        ],
        degreeList: [
          {name: "高中以下", value: 1},
          {name: "高中", value: 2},
          {name: "大专", value: 3},
          {name: "本科", value: 4},
          {name: "研究生", value: 5},
          {name: "博士", value: 6},
        ],
        // 最高学历 == 现在的博士学历
        zgEducation: {},
        yjsEducation: {},
        fullEducation: {},
        zkEducation: {},
        messageDialog: false,
        userMessageConfirmForm: {},
      };
    },
    created() {},
    mounted() {
      let _this = this;
      _this.getNoticeInfo();
    },
    methods: {
      handleClose(done) {
        this.$confirm("确认关闭选择岗位？")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      },
      handleCloseUserMessage(done) {
        this.$confirm("确认关闭个人信息登记表？")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      },
      handleCloseMessageDialog(done) {
        this.$confirm("确认关闭个人信息确认？")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      },
      // 岗位列表
      getPostList() {
        let _this = this;
        _this.post.noticeId = _this.recruitId;
        let parmas = {
          ..._this.post,
        };
        _this.$api.recruitNotice
          .getRecruitPosts(parmas)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              _this.postApplyData = res.data;
              if (_this.signupInfo.id) {
                _this.postApplyData.forEach((item) => {
                  if (item.id == _this.signupInfo.postId) {
                    _this.currentRow = item;
                  }
                });
              }
            }
          })
          .catch(() => {});
      },
      // 选择岗位
      choosePost(row) {
        let _this = this;
        let params = {
          recruitId: _this.recruitId,
          postId: row.id,
          id: _this.signupInfo.id,
        };
        _this.$api.sign
          .checkIsSign(params)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              _this.currentRow = row;
              _this.$forceUpdate();
            } else {
              _this.$layer.alert(res.msg);
              _this.currentRow = {};
              _this.signupInfo.postId = null;
            }
          })
          .catch(() => {})
          .finally(() => {});
      },
      // 岗位报名
      getNoticeInfo() {
        let _this = this;
        let parmas = {
          id: _this.recruitId,
        };
        _this.$api.recruitNotice
          .getRecruitNoticeDetail(parmas)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              _this.noticeInfo = res.data;
            }
          })
          .catch(() => {});
      },
      // 岗位报名按钮
      nextStep(val) {
        let _this = this;
        if (val == "two") {
          if (!_this.signupInfo.id) {
            if (!_this.currentRow.id) {
              _this.$message.error("请选择岗位");
              return;
            } else {
              //查询本招聘公告下的最近的一次报名信息
              _this.getSignupInfoRecent();
              _this.applyMessage = true;
              // 中国地区(省市区)
              _this.getSysArea();
              // 民族
              _this.getNationList();
              // 高校类型
              _this.getSchoolFeatureList();
            }
          } else if (
            _this.signupInfo.status == 0 ||
            _this.signupInfo.status == 1 ||
            _this.signupInfo.status == 2 ||
            _this.signupInfo.status == 3
          ) {
            // 查看报名详情的时候如果有报名数据id就走这个方法
            if (!_this.currentRow.id) {
              _this.$message.error("请选择岗位");
              return;
            } else {
              //查询本招聘公告下的最近的一次报名信息
              _this.getSignUpById(this.signupInfo.id);
              // _this.getSignupInfoRecent();
              _this.applyMessage = true;
              // 中国地区(省市区)
              _this.getSysArea();
              // 民族
              _this.getNationList();
              // 高校类型
              _this.getSchoolFeatureList();
            }
            _this.signupInfo.postId = _this.currentRow.id;
            _this.signupInfo.companyName = _this.currentRow.unit;
            _this.signupInfo.postName = _this.currentRow.name;
            _this.signupInfo.postNum = _this.currentRow.code;
          }
        }
      },
      getUserInfo() {
        let _this = this;
        _this.$api.employee
          .getUserInfo()
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              if (
                !_this.signupInfo.id ||
                _this.signupInfo.status == 0 ||
                _this.signupInfo.status == 3
              ) {
                _this.signupInfo.name = res.data.name;
                _this.signupInfo.gender = res.data.gender;
                _this.signupInfo.birthday = res.data.birthday;
                _this.signupInfo.telephone = res.data.telephone;
                _this.signupInfo.email = res.data.email;
                _this.signupInfo.cardNum = res.data.cardNum;
                _this.signupInfo.headUrl = res.data.headUrl;
                // 用户信息确认框数据
                _this.userMessageConfirmForm.name = res.data.name;
                _this.userMessageConfirmForm.phone = res.data.telephone;
                _this.userMessageConfirmForm.cardNumber = res.data.cardNum;
                _this.userMessageConfirmForm.email = res.data.email;
                _this.userMessageConfirmForm.positionApplied =
                  _this.currentRow.unit;
                _this.userMessageConfirmForm.positionJob = _this.currentRow.name;
                _this.$forceUpdate();
              }
            } else {
              _this.$layer.success(res.msg);
            }
          })
          .catch(() => {})
          .finally(() => {});
      },
      // 查询 中国地区
      getSysArea() {
        let _this = this;
        _this.$api.sign.getSysAreaList().then((res) => {
          // 籍贯
          _this.nativePlaceOptions = res.data;
          // 现住址
          _this.presentAddressOptions = res.data;
        });
      },
      // 查询民族
      getNationList() {
        let _this = this;
        _this.$api.sign.getSelectNationList().then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            _this.nationList.push({
              id: res.data[i].dictCode,
              label: res.data[i].dictLabel,
            });
          }
        });
      },
      // 查询高校类型
      getSchoolFeatureList() {
        let _this = this;
        _this.$api.sign.getSchoolFeatureList().then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            _this.schoolFeatureList.push({
              id: res.data[i].dictCode,
              label: res.data[i].dictLabel,
            });
          }
        });
      },
      getSignupInfoRecent() {
        let _this = this;
        let params = {
          // recruitId: _this.recruitId,
        };
        _this.workExperienceList = [
          {
            id: 1,
            startEndTime: "",
            startTime: null,
            endTime: null,
            uintDept: "",
            post: "",
            duty: "",
          },
          {
            id: 2,
            startEndTime: "",
            startTime: null,
            endTime: null,
            uintDept: "",
            post: "",
            duty: "",
          },
          {
            id: 3,
            startEndTime: "",
            startTime: null,
            endTime: null,
            uintDept: "",
            post: "",
            duty: "",
          },
          {
            id: 4,
            startEndTime: "",
            startTime: null,
            endTime: null,
            uintDept: "",
            post: "",
            duty: "",
          },
        ];
        _this.certificateList = [
          { id: 1, name: "", grade: "", getTime: "", organization: "" },
          { id: 2, name: "", grade: "", getTime: "", organization: "" },
          { id: 3, name: "", grade: "", getTime: "", organization: "" },
          { id: 4, name: "", grade: "", getTime: "", organization: "" },
        ];
        _this.yjsEducation = {};
        _this.zgEducation = {};
        _this.fullEducation = {};
        _this.zkEducation = {};
        _this.partEducation = {};
        _this.$api.sign
          .getUserSignInfoRecent(params)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              if (res.data) {
                _this.signupInfo = res.data;
                _this.signupInfo.id = null;
                _this.signupInfo.status = 0;
                if (_this.signupInfo.zgEducation) {
                  _this.zgEducation = JSON.parse(
                    _this.signupInfo.zgEducation
                  );
                }
                if (_this.signupInfo.yjsEducation) {
                  _this.yjsEducation = JSON.parse(
                    _this.signupInfo.yjsEducation
                  );
                }
                if (_this.signupInfo.workExperience) {
                  _this.workExperienceList = JSON.parse(
                    _this.signupInfo.workExperience
                  );
                }
                if (_this.signupInfo.certificate) {
                  _this.certificateList = JSON.parse(
                    _this.signupInfo.certificate
                  );
                }
                if (_this.signupInfo.fullEducation) {
                  _this.fullEducation = JSON.parse(
                    _this.signupInfo.fullEducation
                  );
                }

                if (_this.signupInfo.partEducation) {
                  _this.partEducation = JSON.parse(
                    _this.signupInfo.partEducation
                  );
                }
                if (_this.signupInfo.zkEducation) {
                  _this.zkEducation = JSON.parse(_this.signupInfo.zkEducation);
                }
              }
              _this.signupInfo.postId = _this.currentRow.id;
              _this.signupInfo.companyName = _this.currentRow.unit;
              _this.signupInfo.postName = _this.currentRow.name;
              _this.signupInfo.postNum = _this.currentRow.code;
              // 查询用户信息
              _this.getUserInfo();
            } else {
              _this.$layer.alert(res.msg);
            }
          })
          .catch(() => {})
          .finally(() => {});
      },
      getSignUpById(id) {
        let _this = this;
        let params = {
          id: id,
        };
        _this.workExperienceList = [
          {
            id: 1,
            startEndTime: "",
            startTime: null,
            endTime: null,
            uintDept: "",
            post: "",
            duty: "",
          },
          {
            id: 2,
            startEndTime: "",
            startTime: null,
            endTime: null,
            uintDept: "",
            post: "",
            duty: "",
          },
          {
            id: 3,
            startEndTime: "",
            startTime: null,
            endTime: null,
            uintDept: "",
            post: "",
            duty: "",
          },
          {
            id: 4,
            startEndTime: "",
            startTime: null,
            endTime: null,
            uintDept: "",
            post: "",
            duty: "",
          },
        ];
        _this.certificateList = [
          { id: 1, name: "", grade: "", getTime: "", organization: "" },
          { id: 2, name: "", grade: "", getTime: "", organization: "" },
          { id: 3, name: "", grade: "", getTime: "", organization: "" },
          { id: 4, name: "", grade: "", getTime: "", organization: "" },
        ];
        _this.zgEducation = {};
        _this.yjsEducation = {};
        _this.fullEducation = {};
        _this.zkEducation = {};
        _this.partEducation = {};
        _this.$api.sign
          .getById(params)
          .then((res) => {
            if (res.code == this.$commons.RespCode.success) {
              if (res.data) {
                if (res.data.status == 1 || res.data.status == 2){
                  _this.disabled = true;
                }else if (res.data.status != 1 && res.data.status != 2){
                  _this.disabled = false;
                }
                _this.signupInfo = res.data;

                if (_this.signupInfo.workExperience) {
                  _this.workExperienceList = JSON.parse(
                    _this.signupInfo.workExperience
                  );
                }
                if (_this.signupInfo.certificate) {
                  _this.certificateList = JSON.parse(
                    _this.signupInfo.certificate
                  );
                }
                if (_this.signupInfo.zgEducation) {
                  _this.zgEducation = JSON.parse(_this.signupInfo.zgEducation);
                  if (
                    !_this.zgEducation.startEndTime &&
                    _this.zgEducation.startTime &&
                    _this.zgEducation.endTime
                  ) {
                    _this.zgEducation.startEndTime = [];
                    _this.zgEducation.startEndTime.push(
                      _this.zgEducation.startTime
                    );
                    _this.zgEducation.startEndTime.push(
                      _this.zgEducation.endTime
                    );
                  }
                }
                if (_this.signupInfo.yjsEducation) {
                  _this.yjsEducation = JSON.parse(_this.signupInfo.yjsEducation);
                  if (
                    !_this.yjsEducation.startEndTime &&
                    _this.yjsEducation.startTime &&
                    _this.yjsEducation.endTime
                  ) {
                    _this.yjsEducation.startEndTime = [];
                    _this.yjsEducation.startEndTime.push(
                      _this.yjsEducation.startTime
                    );
                    _this.yjsEducation.startEndTime.push(
                      _this.yjsEducation.endTime
                    );
                  }
                }
                if (_this.signupInfo.fullEducation) {
                  _this.fullEducation = JSON.parse(
                    _this.signupInfo.fullEducation
                  );
                  if (
                    !_this.fullEducation.startEndTime &&
                    _this.fullEducation.startTime &&
                    _this.fullEducation.endTime
                  ) {
                    _this.fullEducation.startEndTime = [];
                    _this.fullEducation.startEndTime.push(
                      _this.fullEducation.startTime
                    );
                    _this.fullEducation.startEndTime.push(
                      _this.fullEducation.endTime
                    );
                  }
                }
                if (_this.signupInfo.zkEducation) {
                  _this.zkEducation = JSON.parse(_this.signupInfo.zkEducation);
                  if (
                    !_this.zkEducation.startEndTime &&
                    _this.zkEducation.startTime &&
                    _this.zkEducation.endTime
                  ) {
                    _this.zkEducation.startEndTime = [];
                    _this.zkEducation.startEndTime.push(
                      _this.zkEducation.startTime
                    );
                    _this.zkEducation.startEndTime.push(
                      _this.zkEducation.endTime
                    );
                  }
                }
                if (_this.signupInfo.partEducation) {
                  _this.partEducation = JSON.parse(
                    _this.signupInfo.partEducation
                  );
                  if (
                    !_this.partEducation.startEndTime &&
                    _this.partEducation.startTime &&
                    _this.partEducation.endTime
                  ) {
                    _this.partEducation.startEndTime = [];
                    _this.partEducation.startEndTime.push(
                      _this.partEducation.startTime
                    );
                    _this.partEducation.startEndTime.push(
                      _this.partEducation.endTime
                    );
                  }
                }
                if (_this.signupInfo.nativePlace) {
                  _this.signupInfo.nativePlace = JSON.parse(
                    _this.signupInfo.nativePlace
                  );
                }
                if (_this.signupInfo.current) {
                  _this.signupInfo.current = JSON.parse(
                    _this.signupInfo.current
                  );
                }
                if (
                  _this.signupInfo.status == 1 ||
                  _this.signupInfo.status == 0 ||
                  _this.signupInfo.status == 3
                ) {
                  _this.getUserInfo();
                } else {
                  _this.currentStep = "two";
                }
              }
            } else {
              _this.$layer.alert(res.msg);
            }
            _this.getPostList();
            _this.getNoticeInfo();
          })
          .catch(() => {})
          .finally(() => {});
      },
      onTimeChange(e,index){
        let _this = this;
        _this.workExperienceList[index].startTime = e[0];
        _this.workExperienceList[index].endTime = e[1];
      },
      onDeptChange(e,index){
        let _this = this;
        _this.workExperienceList[index].uintDept = e;
      },
      onPostChange(e,index){
        let _this = this;
        _this.workExperienceList[index].post = e;
      },
      onDutyChange(e,index){
        let _this = this;
        _this.workExperienceList[index].duty = e;
      },
      onNameChange(e,index){
        let _this = this;
        _this.certificateList[index].name = e;
      },
      onGradeChange(e,index){
        let _this = this;
        _this.certificateList[index].grade = e;
      },
      onGetTimeChange(e,index){
        let _this = this;
        _this.certificateList[index].getTime = e;
      },
      onOrganizationChange(e,index){
        let _this = this;
        _this.certificateList[index].organization = e;
      },
      // 暂存按钮操作
      zancun(val){
        let _this = this;
        if (val && val != "tijiao"){
          if (!_this.signupInfo.nation) {
            _this.$layer.alert("请选择民族!");
            return;
          }
          if (!_this.signupInfo.birthAddress) {
            _this.$layer.alert("请填写出生地!");
            return;
          }
          if (!_this.signupInfo.political) {
            _this.$layer.alert("请选择政治面貌!");
            return;
          }
          if (!_this.signupInfo.isMarry) {
            _this.$layer.alert("请选择婚姻状况!");
            return;
          }
          if (!_this.signupInfo.health) {
            _this.$layer.alert("请选择健康状态!");
            return;
          }
          if (!_this.signupInfo.workTime) {
            _this.$layer.alert("请填写参加工作时间!");
            return;
          }
          if (!_this.signupInfo.workCompany) {
            _this.$layer.alert("请填写现工作单位!");
            return;
          }
          if (!_this.signupInfo.workDeptPost) {
            _this.$layer.alert("请填写现工作部门及岗位!");
            return;
          }
          // 校验籍贯和现住址
          if(!_this.signupInfo.nativePlace || !_this.signupInfo.nativeAddress || !_this.signupInfo.current || !_this.signupInfo.currentAddress) {
            _this.$layer.alert("请检查籍贯或现住址是否选择和填写！");
            return;
          }
          if (_this.signupInfo.educationType == 1){
            if (_this.signupInfo.degree == 6){
              // 学历为博士，博士校验
              // 学历为博士，博士校验
              if (_this.zgEducation) {
                if (
                  !_this.zgEducation.startEndTime ||
                  _this.zgEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择博士学历的起止时间");
                  return;
                }
                if (!_this.zgEducation.college) {
                  _this.$layer.alert("请填写博士学历的院校!");
                  return;
                }
                if (!_this.zgEducation.major) {
                  _this.$layer.alert("请填写博士学历的专业!");
                  return;
                }
                if (!_this.zgEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zgEducation.schoolFeature) {
                  _this.$layer.alert("请选择博士学历的院校类别!");
                  return;
                }
                _this.zgEducation.startTime = _this.zgEducation.startEndTime[0];
                _this.zgEducation.endTime = _this.zgEducation.startEndTime[1];
              }
              if (
                !this.zgEducation.startEndTime ||
                !_this.zgEducation.college ||
                !_this.zgEducation.major ||
                !_this.zgEducation.degree ||
                !_this.zgEducation.schoolFeature
              ) {
                _this.zgEducation = {};
              }
              // 研究生校验
              if (_this.yjsEducation) {
                if (
                  !_this.yjsEducation.startEndTime ||
                  _this.yjsEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择研究生学历的起止时间");
                  return;
                }
                if (!_this.yjsEducation.college) {
                  _this.$layer.alert("请填写研究生学历的院校!");
                  return;
                }
                if (!_this.yjsEducation.major) {
                  _this.$layer.alert("请填写研究生学历的专业!");
                  return;
                }
                if (!_this.yjsEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.yjsEducation.schoolFeature) {
                  _this.$layer.alert("请选择研究生学历的院校类别!");
                  return;
                }
                _this.yjsEducation.startTime = _this.yjsEducation.startEndTime[0];
                _this.yjsEducation.endTime = _this.yjsEducation.startEndTime[1];
              }
              if (
                !this.yjsEducation.startEndTime ||
                !_this.yjsEducation.college ||
                !_this.yjsEducation.major ||
                !_this.yjsEducation.degree ||
                !_this.yjsEducation.schoolFeature
              ) {
                _this.yjsEducation = {};
              }
              // 本科学历校验
              if (_this.fullEducation) {
                if (
                  !_this.fullEducation.startEndTime ||
                  _this.fullEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择本科学历的起止时间");
                  return;
                }
                if (!_this.fullEducation.college) {
                  _this.$layer.alert("请填写本科学历的院校!");
                  return;
                }
                if (!_this.fullEducation.major) {
                  _this.$layer.alert("请填写本科学历的专业!");
                  return;
                }
                if (!_this.fullEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.fullEducation.schoolFeature) {
                  _this.$layer.alert("请选择本科学历的院校类别!");
                  return;
                }
                _this.fullEducation.startTime = _this.fullEducation.startEndTime[0];
                _this.fullEducation.endTime = _this.fullEducation.startEndTime[1];
              }
              if (
                !this.fullEducation.startEndTime ||
                !_this.fullEducation.college ||
                !_this.fullEducation.major ||
                !_this.fullEducation.degree ||
                !_this.fullEducation.schoolFeature
              ) {
                _this.fullEducation = {};
              }
              // 专科及以下校验
              if (_this.zkEducation) {
                if (
                  !_this.zkEducation.startEndTime ||
                  _this.zkEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择专科及以下学历的起止时间");
                  return;
                }
                if (!_this.zkEducation.college) {
                  _this.$layer.alert("请填写专科及以下学历的院校!");
                  return;
                }
                if (!_this.zkEducation.major) {
                  _this.$layer.alert("请填写专科及以下学历的专业!");
                  return;
                }
                if (!_this.zkEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zkEducation.schoolFeature) {
                  _this.$layer.alert("请选择专科及以下学历的院校类别!");
                  return;
                }
                _this.zkEducation.startTime = _this.zkEducation.startEndTime[0];
                _this.zkEducation.endTime = _this.zkEducation.startEndTime[1];
              }
              if (
                !this.zkEducation.startEndTime ||
                !_this.zkEducation.college ||
                !_this.zkEducation.major ||
                !_this.zkEducation.degree ||
                !_this.zkEducation.schoolFeature
              ) {
                _this.zkEducation = {};
              }
            }else if (_this.signupInfo.degree == 5){
              // 学历为研究生 研究生校验
              if (_this.yjsEducation) {
                if (
                  !_this.yjsEducation.startEndTime ||
                  _this.yjsEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择研究生学历的起止时间");
                  return;
                }
                if (!_this.yjsEducation.college) {
                  _this.$layer.alert("请填写研究生学历的院校!");
                  return;
                }
                if (!_this.yjsEducation.major) {
                  _this.$layer.alert("请填写研究生学历的专业!");
                  return;
                }
                if (!_this.yjsEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.yjsEducation.schoolFeature) {
                  _this.$layer.alert("请选择研究生学历的院校类别!");
                  return;
                }
                _this.yjsEducation.startTime = _this.yjsEducation.startEndTime[0];
                _this.yjsEducation.endTime = _this.yjsEducation.startEndTime[1];
              }
              if (
                !this.yjsEducation.startEndTime ||
                !_this.yjsEducation.college ||
                !_this.yjsEducation.major ||
                !_this.yjsEducation.degree ||
                !_this.yjsEducation.schoolFeature
              ) {
                _this.yjsEducation = {};
              }
              // 本科学历校验
              if (_this.fullEducation) {
                if (
                  !_this.fullEducation.startEndTime ||
                  _this.fullEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择本科学历的起止时间");
                  return;
                }
                if (!_this.fullEducation.college) {
                  _this.$layer.alert("请填写本科学历的院校!");
                  return;
                }
                if (!_this.fullEducation.major) {
                  _this.$layer.alert("请填写本科学历的专业!");
                  return;
                }
                if (!_this.fullEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.fullEducation.schoolFeature) {
                  _this.$layer.alert("请选择本科学历的院校类别!");
                  return;
                }
                _this.fullEducation.startTime = _this.fullEducation.startEndTime[0];
                _this.fullEducation.endTime = _this.fullEducation.startEndTime[1];
              }
              if (
                !this.fullEducation.startEndTime ||
                !_this.fullEducation.college ||
                !_this.fullEducation.major ||
                !_this.fullEducation.degree ||
                !_this.fullEducation.schoolFeature
              ) {
                _this.fullEducation = {};
              }
              // 专科及以下校验
              if (_this.zkEducation) {
                if (
                  !_this.zkEducation.startEndTime ||
                  _this.zkEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择专科及以下学历的起止时间");
                  return;
                }
                if (!_this.zkEducation.college) {
                  _this.$layer.alert("请填写专科及以下学历的院校!");
                  return;
                }
                if (!_this.zkEducation.major) {
                  _this.$layer.alert("请填写专科及以下学历的专业!");
                  return;
                }
                if (!_this.zkEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zkEducation.schoolFeature) {
                  _this.$layer.alert("请选择专科及以下学历的院校类别!");
                  return;
                }
                _this.zkEducation.startTime = _this.zkEducation.startEndTime[0];
                _this.zkEducation.endTime = _this.zkEducation.startEndTime[1];
              }
              if (
                !this.zkEducation.startEndTime ||
                !_this.zkEducation.college ||
                !_this.zkEducation.major ||
                !_this.zkEducation.degree ||
                !_this.zkEducation.schoolFeature
              ) {
                _this.zkEducation = {};
              }
            }else if (_this.signupInfo.degree == 4){
              // 学历为本科 本科校验
              if (_this.fullEducation) {
                if (
                  !_this.fullEducation.startEndTime ||
                  _this.fullEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择本科学历的起止时间");
                  return;
                }
                if (!_this.fullEducation.college) {
                  _this.$layer.alert("请填写本科学历的院校!");
                  return;
                }
                if (!_this.fullEducation.major) {
                  _this.$layer.alert("请填写本科学历的专业!");
                  return;
                }
                if (!_this.fullEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.fullEducation.schoolFeature) {
                  _this.$layer.alert("请选择本科学历的院校类别!");
                  return;
                }
                _this.fullEducation.startTime = _this.fullEducation.startEndTime[0];
                _this.fullEducation.endTime = _this.fullEducation.startEndTime[1];
              }
              if (
                !this.fullEducation.startEndTime ||
                !_this.fullEducation.college ||
                !_this.fullEducation.major ||
                !_this.fullEducation.degree ||
                !_this.fullEducation.schoolFeature
              ) {
                _this.fullEducation = {};
              }
              // 专科及以下校验
              if (_this.zkEducation) {
                if (
                  !_this.zkEducation.startEndTime ||
                  _this.zkEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择专科及以下学历的起止时间");
                  return;
                }
                if (!_this.zkEducation.college) {
                  _this.$layer.alert("请填写专科及以下学历的院校!");
                  return;
                }
                if (!_this.zkEducation.major) {
                  _this.$layer.alert("请填写专科及以下学历的专业!");
                  return;
                }
                if (!_this.zkEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zkEducation.schoolFeature) {
                  _this.$layer.alert("请选择专科及以下学历的院校类别!");
                  return;
                }
                _this.zkEducation.startTime = _this.zkEducation.startEndTime[0];
                _this.zkEducation.endTime = _this.zkEducation.startEndTime[1];
              }
              if (
                !this.zkEducation.startEndTime ||
                !_this.zkEducation.college ||
                !_this.zkEducation.major ||
                !_this.zkEducation.degree ||
                !_this.zkEducation.schoolFeature
              ) {
                _this.zkEducation = {};
              }
            }else {
              // 学历为专科及以下 专科及以下校验
              if (_this.zkEducation) {
                if (
                  !_this.zkEducation.startEndTime ||
                  _this.zkEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择专科及以下学历的起止时间");
                  return;
                }
                if (!_this.zkEducation.college) {
                  _this.$layer.alert("请填写专科及以下学历的院校!");
                  return;
                }
                if (!_this.zkEducation.major) {
                  _this.$layer.alert("请填写专科及以下学历的专业!");
                  return;
                }
                if (!_this.zkEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zkEducation.schoolFeature) {
                  _this.$layer.alert("请选择专科及以下学历的院校类别!");
                  return;
                }
                _this.zkEducation.startTime = _this.zkEducation.startEndTime[0];
                _this.zkEducation.endTime = _this.zkEducation.startEndTime[1];
              }
              if (
                !this.zkEducation.startEndTime ||
                !_this.zkEducation.college ||
                !_this.zkEducation.major ||
                !_this.zkEducation.degree ||
                !_this.zkEducation.schoolFeature
              ) {
                _this.zkEducation = {};
              }
            }
          }else if (_this.signupInfo.educationType == 2){
            // 非全日制校验
            if (
              _this.partEducation &&
              JSON.stringify(_this.partEducation) != "{}" &&
              (_this.partEducation.startEndTime ||
                _this.partEducation.college ||
                _this.partEducation.major ||
                _this.partEducation.degree)
            ) {
              if (
                !_this.partEducation.startEndTime ||
                _this.partEducation.startEndTime.length != 2
              ) {
                _this.$layer.alert("请选择开始或结束时间");
                return;
              }
              if (!_this.partEducation.college) {
                _this.$layer.alert("请填写院校!");
                return;
              }
              if (!_this.partEducation.major) {
                _this.$layer.alert("请填写专业!");
                return;
              }
              if (!_this.partEducation.degree) {
                _this.$layer.alert("请选择学历!");
                return;
              }
              if (!_this.partEducation.schoolFeature) {
                _this.$layer.alert("请选择院校类别!");
                return;
              }
              _this.partEducation.startTime = _this.partEducation.startEndTime[0];
              _this.partEducation.endTime = _this.partEducation.startEndTime[1];
            }
            if (
              !this.partEducation.startEndTime ||
              !_this.partEducation.college ||
              !_this.partEducation.major ||
              !_this.partEducation.degree
            ) {
              _this.partEducation = {};
            }
          }

          _this.signupInfo.postId = _this.currentRow.id;
          _this.signupInfo.zgEducation = JSON.stringify(_this.zgEducation);
          _this.signupInfo.yjsEducation = JSON.stringify(_this.yjsEducation);
          _this.signupInfo.fullEducation = JSON.stringify(_this.fullEducation);
          _this.signupInfo.zkEducation = JSON.stringify(_this.zkEducation);
          _this.signupInfo.partEducation = JSON.stringify(_this.partEducation);

          _this.signupInfo.workExperience = JSON.stringify(
            _this.workExperienceList
          );
          _this.signupInfo.certificate = JSON.stringify(_this.certificateList);

          _this.signupInfo.recruitId = _this.recruitId;
          _this.signupInfo.nativePlace = JSON.stringify(_this.signupInfo.nativePlace);
          _this.signupInfo.current = JSON.stringify(_this.signupInfo.current);
        }
        if (_this.signupInfo.id) {
          if (val == "tijiao") {
            if (_this.noticeInfo.sendResume == 0) {
              _this.signupInfo.status = 1;
            } else {
              _this.signupInfo.status = -1;
            }
          } else {
            _this.signupInfo.status = 0;
          }
          _this.$api.sign
            .updateSignInfo(_this.signupInfo)
            .then((res) => {
              if (res.code == this.$commons.RespCode.success) {
                _this.$layer.alert("操作成功");
              } else {
                _this.$layer.alert(res.msg);
              }
            })
            .catch(() => {})
            .finally(() => {});
        } else {
          _this.$layer.load(0, { shade: 0.6 });
          if (val == "tijiao") {
            if (_this.noticeInfo.sendResume == 0) {
              _this.signupInfo.status = 1;
            } else {
              _this.signupInfo.status = -1;
            }
          } else {
            _this.signupInfo.status = 0;
          }
          _this.signupInfo.recruitId = _this.recruitId;

          _this.$api.sign
            .addSignInfo(_this.signupInfo)
            .then((res) => {
              if (res.code == this.$commons.RespCode.success) {
                _this.signupInfo.id = res.data;
                if (val == "tijiao") {
                  _this.$layer.alert("提交成功", function () {
                    _this.$layer.closeAll();
                  });
                } else {
                  _this.$layer.alert("保存成功", function () {
                    _this.$layer.closeAll();
                  });
                }
              } else {
                _this.$layer.alert(res.msg);
                _this.$layer.closeAll();
              }
            })
            .catch(() => {})
            .finally(() => {});
        }
        _this.applyMessage = false;
        _this.showPostApply = false;
      },
      // 提交按钮
      messageConfirm(val) {
        let _this = this;
        if (val && val != "zancun") {
          if (!_this.signupInfo.nation) {
            _this.$layer.alert("请选择民族!");
            return;
          }
          if (!_this.signupInfo.birthAddress) {
            _this.$layer.alert("请填写出生地!");
            return;
          }
          if (!_this.signupInfo.political) {
            _this.$layer.alert("请选择政治面貌!");
            return;
          }
          if (!_this.signupInfo.isMarry) {
            _this.$layer.alert("请选择婚姻状况!");
            return;
          }
          if (!_this.signupInfo.health) {
            _this.$layer.alert("请选择健康状态!");
            return;
          }
          if (!_this.signupInfo.workTime) {
            _this.$layer.alert("请填写参加工作时间!");
            return;
          }
          if (!_this.signupInfo.workCompany) {
            _this.$layer.alert("请填写现工作单位!");
            return;
          }
          if (!_this.signupInfo.workDeptPost) {
            _this.$layer.alert("请填写现工作部门及岗位!");
            return;
          }
          // 校验籍贯和现住址
          if(!_this.signupInfo.nativePlace || !_this.signupInfo.nativeAddress || !_this.signupInfo.current || !_this.signupInfo.currentAddress) {
            _this.$layer.alert("请检查籍贯或现住址是否选择和填写！");
            return;
          }
          if(!_this.signupInfo.educationType) {
            _this.$layer.alert("请选择教育类型!");
            return;
          }
          if(!_this.signupInfo.degree) {
            _this.$layer.alert("请选择学历类型!");
            return;
          }
        //   _this.zgEducation &&
        //   JSON.stringify(_this.zgEducation) != "{}" &&
        //   (_this.zgEducation.startEndTime ||
        //     _this.zgEducation.college ||
        //     _this.zgEducation.major ||
        //     _this.zgEducation.degree)
        // )
      if (_this.signupInfo.educationType == 1){
            if (_this.signupInfo.degree == 6){
              // 学历为博士，博士校验
              if (_this.zgEducation) {
                console.log("_this.zgEducation", _this.zgEducation);
                console.log("JSON.stringify(_this.zgEducation)", JSON.stringify(_this.zgEducation));
                if (
                  !_this.zgEducation.startEndTime ||
                  _this.zgEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择博士学历的起止时间");
                  return;
                }
                if (!_this.zgEducation.college) {
                  _this.$layer.alert("请填写博士学历的院校!");
                  return;
                }
                if (!_this.zgEducation.major) {
                  _this.$layer.alert("请填写博士学历的专业!");
                  return;
                }
                if (!_this.zgEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zgEducation.schoolFeature) {
                  _this.$layer.alert("请选择博士学历的院校类别!");
                  return;
                }
                _this.zgEducation.startTime = _this.zgEducation.startEndTime[0];
                _this.zgEducation.endTime = _this.zgEducation.startEndTime[1];
              }
              if (
                !this.zgEducation.startEndTime ||
                !_this.zgEducation.college ||
                !_this.zgEducation.major ||
                !_this.zgEducation.degree ||
                !_this.zgEducation.schoolFeature
              ) {
                _this.zgEducation = {};
              }
              // 研究生校验
              if (_this.yjsEducation) {
                if (
                  !_this.yjsEducation.startEndTime ||
                  _this.yjsEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择研究生学历的起止时间");
                  return;
                }
                if (!_this.yjsEducation.college) {
                  _this.$layer.alert("请填写研究生学历的院校!");
                  return;
                }
                if (!_this.yjsEducation.major) {
                  _this.$layer.alert("请填写研究生学历的专业!");
                  return;
                }
                if (!_this.yjsEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.yjsEducation.schoolFeature) {
                  _this.$layer.alert("请选择研究生学历的院校类别!");
                  return;
                }
                _this.yjsEducation.startTime = _this.yjsEducation.startEndTime[0];
                _this.yjsEducation.endTime = _this.yjsEducation.startEndTime[1];
              }
              if (
                !this.yjsEducation.startEndTime ||
                !_this.yjsEducation.college ||
                !_this.yjsEducation.major ||
                !_this.yjsEducation.degree ||
                !_this.yjsEducation.schoolFeature
              ) {
                _this.yjsEducation = {};
              }
              // 本科学历校验
              if (_this.fullEducation) {
                if (
                  !_this.fullEducation.startEndTime ||
                  _this.fullEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择本科学历的起止时间");
                  return;
                }
                if (!_this.fullEducation.college) {
                  _this.$layer.alert("请填写本科学历的院校!");
                  return;
                }
                if (!_this.fullEducation.major) {
                  _this.$layer.alert("请填写本科学历的专业!");
                  return;
                }
                if (!_this.fullEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.fullEducation.schoolFeature) {
                  _this.$layer.alert("请选择本科学历的院校类别!");
                  return;
                }
                _this.fullEducation.startTime = _this.fullEducation.startEndTime[0];
                _this.fullEducation.endTime = _this.fullEducation.startEndTime[1];
              }
              if (
                !this.fullEducation.startEndTime ||
                !_this.fullEducation.college ||
                !_this.fullEducation.major ||
                !_this.fullEducation.degree ||
                !_this.fullEducation.schoolFeature
              ) {
                _this.fullEducation = {};
              }
              // 专科及以下校验
              if (_this.zkEducation) {
                if (
                  !_this.zkEducation.startEndTime ||
                  _this.zkEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择专科及以下学历的起止时间");
                  return;
                }
                if (!_this.zkEducation.college) {
                  _this.$layer.alert("请填写专科及以下学历的院校!");
                  return;
                }
                if (!_this.zkEducation.major) {
                  _this.$layer.alert("请填写专科及以下学历的专业!");
                  return;
                }
                if (!_this.zkEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zkEducation.schoolFeature) {
                  _this.$layer.alert("请选择专科及以下学历的院校类别!");
                  return;
                }
                _this.zkEducation.startTime = _this.zkEducation.startEndTime[0];
                _this.zkEducation.endTime = _this.zkEducation.startEndTime[1];
              }
              if (
                !this.zkEducation.startEndTime ||
                !_this.zkEducation.college ||
                !_this.zkEducation.major ||
                !_this.zkEducation.degree ||
                !_this.zkEducation.schoolFeature
              ) {
                _this.zkEducation = {};
              }
            }else if (_this.signupInfo.degree == 5){
              // 学历为研究生 研究生校验
              if (_this.yjsEducation) {
                if (
                  !_this.yjsEducation.startEndTime ||
                  _this.yjsEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择研究生学历的起止时间");
                  return;
                }
                if (!_this.yjsEducation.college) {
                  _this.$layer.alert("请填写研究生学历的院校!");
                  return;
                }
                if (!_this.yjsEducation.major) {
                  _this.$layer.alert("请填写研究生学历的专业!");
                  return;
                }
                if (!_this.yjsEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.yjsEducation.schoolFeature) {
                  _this.$layer.alert("请选择研究生学历的院校类别!");
                  return;
                }
                _this.yjsEducation.startTime = _this.yjsEducation.startEndTime[0];
                _this.yjsEducation.endTime = _this.yjsEducation.startEndTime[1];
              }
              if (
                !this.yjsEducation.startEndTime ||
                !_this.yjsEducation.college ||
                !_this.yjsEducation.major ||
                !_this.yjsEducation.degree ||
                !_this.yjsEducation.schoolFeature
              ) {
                _this.yjsEducation = {};
              }
              // 本科学历校验
              if (_this.fullEducation) {
                if (
                  !_this.fullEducation.startEndTime ||
                  _this.fullEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择本科学历的起止时间");
                  return;
                }
                if (!_this.fullEducation.college) {
                  _this.$layer.alert("请填写本科学历的院校!");
                  return;
                }
                if (!_this.fullEducation.major) {
                  _this.$layer.alert("请填写本科学历的专业!");
                  return;
                }
                if (!_this.fullEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.fullEducation.schoolFeature) {
                  _this.$layer.alert("请选择本科学历的院校类别!");
                  return;
                }
                _this.fullEducation.startTime = _this.fullEducation.startEndTime[0];
                _this.fullEducation.endTime = _this.fullEducation.startEndTime[1];
              }
              if (
                !this.fullEducation.startEndTime ||
                !_this.fullEducation.college ||
                !_this.fullEducation.major ||
                !_this.fullEducation.degree ||
                !_this.fullEducation.schoolFeature
              ) {
                _this.fullEducation = {};
              }
              // 专科及以下校验
              if (_this.zkEducation) {
                if (
                  !_this.zkEducation.startEndTime ||
                  _this.zkEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择专科及以下学历的起止时间");
                  return;
                }
                if (!_this.zkEducation.college) {
                  _this.$layer.alert("请填写专科及以下学历的院校!");
                  return;
                }
                if (!_this.zkEducation.major) {
                  _this.$layer.alert("请填写专科及以下学历的专业!");
                  return;
                }
                if (!_this.zkEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zkEducation.schoolFeature) {
                  _this.$layer.alert("请选择专科及以下学历的院校类别!");
                  return;
                }
                _this.zkEducation.startTime = _this.zkEducation.startEndTime[0];
                _this.zkEducation.endTime = _this.zkEducation.startEndTime[1];
              }
              if (
                !this.zkEducation.startEndTime ||
                !_this.zkEducation.college ||
                !_this.zkEducation.major ||
                !_this.zkEducation.degree ||
                !_this.zkEducation.schoolFeature
              ) {
                _this.zkEducation = {};
              }
            }else if (_this.signupInfo.degree == 4){
              // 学历为本科 本科校验
              if (_this.fullEducation) {
                if (
                  !_this.fullEducation.startEndTime ||
                  _this.fullEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择本科学历的起止时间");
                  return;
                }
                if (!_this.fullEducation.college) {
                  _this.$layer.alert("请填写本科学历的院校!");
                  return;
                }
                if (!_this.fullEducation.major) {
                  _this.$layer.alert("请填写本科学历的专业!");
                  return;
                }
                if (!_this.fullEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.fullEducation.schoolFeature) {
                  _this.$layer.alert("请选择本科学历的院校类别!");
                  return;
                }
                _this.fullEducation.startTime = _this.fullEducation.startEndTime[0];
                _this.fullEducation.endTime = _this.fullEducation.startEndTime[1];
              }
              if (
                !this.fullEducation.startEndTime ||
                !_this.fullEducation.college ||
                !_this.fullEducation.major ||
                !_this.fullEducation.degree ||
                !_this.fullEducation.schoolFeature
              ) {
                _this.fullEducation = {};
              }
              // 专科及以下校验
              if (_this.zkEducation) {
                if (
                  !_this.zkEducation.startEndTime ||
                  _this.zkEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择专科及以下学历的起止时间");
                  return;
                }
                if (!_this.zkEducation.college) {
                  _this.$layer.alert("请填写专科及以下学历的院校!");
                  return;
                }
                if (!_this.zkEducation.major) {
                  _this.$layer.alert("请填写专科及以下学历的专业!");
                  return;
                }
                if (!_this.zkEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zkEducation.schoolFeature) {
                  _this.$layer.alert("请选择专科及以下学历的院校类别!");
                  return;
                }
                _this.zkEducation.startTime = _this.zkEducation.startEndTime[0];
                _this.zkEducation.endTime = _this.zkEducation.startEndTime[1];
              }
              if (
                !this.zkEducation.startEndTime ||
                !_this.zkEducation.college ||
                !_this.zkEducation.major ||
                !_this.zkEducation.degree ||
                !_this.zkEducation.schoolFeature
              ) {
                _this.zkEducation = {};
              }
            }else {
              // 学历为专科及以下 专科及以下校验
              if (_this.zkEducation) {
                if (
                  !_this.zkEducation.startEndTime ||
                  _this.zkEducation.startEndTime.length != 2
                ) {
                  _this.$layer.alert("请选择专科及以下学历的起止时间");
                  return;
                }
                if (!_this.zkEducation.college) {
                  _this.$layer.alert("请填写专科及以下学历的院校!");
                  return;
                }
                if (!_this.zkEducation.major) {
                  _this.$layer.alert("请填写专科及以下学历的专业!");
                  return;
                }
                if (!_this.zkEducation.degree) {
                  _this.$layer.alert("请选择学历!");
                  return;
                }
                if (!_this.zkEducation.schoolFeature) {
                  _this.$layer.alert("请选择专科及以下学历的院校类别!");
                  return;
                }
                _this.zkEducation.startTime = _this.zkEducation.startEndTime[0];
                _this.zkEducation.endTime = _this.zkEducation.startEndTime[1];
              }
              if (
                !this.zkEducation.startEndTime ||
                !_this.zkEducation.college ||
                !_this.zkEducation.major ||
                !_this.zkEducation.degree ||
                !_this.zkEducation.schoolFeature
              ) {
                _this.zkEducation = {};
              }
            }
          }else if (_this.signupInfo.educationType == 2){
            // 非全日制校验
            if (_this.partEducation) {
              if (
                !_this.partEducation.startEndTime ||
                _this.partEducation.startEndTime.length != 2
              ) {
                _this.$layer.alert("请选择开始或结束时间");
                return;
              }
              if (!_this.partEducation.college) {
                _this.$layer.alert("请填写院校!");
                return;
              }
              if (!_this.partEducation.major) {
                _this.$layer.alert("请填写专业!");
                return;
              }
              if (!_this.partEducation.degree) {
                _this.$layer.alert("请选择学历!");
                return;
              }
              if (!_this.partEducation.schoolFeature) {
                _this.$layer.alert("请选择院校类别!");
                return;
              }
              _this.partEducation.startTime = _this.partEducation.startEndTime[0];
              _this.partEducation.endTime = _this.partEducation.startEndTime[1];
            }
            if (
              !this.partEducation.startEndTime ||
              !_this.partEducation.college ||
              !_this.partEducation.major ||
              !_this.partEducation.degree
            ) {
              _this.partEducation = {};
            }
          }
          _this.signupInfo.postId = _this.currentRow.id;
          _this.signupInfo.zgEducation = JSON.stringify(_this.zgEducation);
          _this.signupInfo.yjsEducation = JSON.stringify(_this.yjsEducation);
          _this.signupInfo.fullEducation = JSON.stringify(_this.fullEducation);
          _this.signupInfo.zkEducation = JSON.stringify(_this.zkEducation);
          _this.signupInfo.partEducation = JSON.stringify(_this.partEducation);

          _this.signupInfo.workExperience = JSON.stringify(
            _this.workExperienceList
          );
          _this.signupInfo.certificate = JSON.stringify(_this.certificateList);

          _this.signupInfo.recruitId = _this.recruitId;
          _this.signupInfo.nativePlace = JSON.stringify(_this.signupInfo.nativePlace);
          _this.signupInfo.current = JSON.stringify(_this.signupInfo.current);
          _this.messageDialog = true;
        }
      },
      userMessageCancel() {
        let _this = this
        _this.messageDialog = false;
      },
      userMessageConfirm(val) {
        let _this = this
        if (_this.signupInfo.id) {
          if (val == "tijiao") {
            if (_this.noticeInfo.sendResume == 0) {
              _this.signupInfo.status = 1;
            } else {
              _this.signupInfo.status = -1;
            }
          } else {
            _this.signupInfo.status = 0;
          }
          _this.$api.sign
            .updateSignInfo(_this.signupInfo)
            .then((res) => {
              if (res.code == this.$commons.RespCode.success) {
                _this.$layer.alert("操作成功");
              } else {
                _this.$layer.alert(res.msg);
              }
            })
            .catch(() => {})
            .finally(() => {});
        } else {
          _this.$layer.load(0, { shade: 0.6 });
          if (val == "tijiao") {
            if (_this.noticeInfo.sendResume == 0) {
              _this.signupInfo.status = 1;
            } else {
              _this.signupInfo.status = -1;
            }
          } else {
            _this.signupInfo.status = 0;
          }
          _this.signupInfo.recruitId = _this.recruitId;

          _this.$api.sign
            .addSignInfo(_this.signupInfo)
            .then((res) => {
              if (res.code == this.$commons.RespCode.success) {
                _this.signupInfo.id = res.data;
                if (val == "tijiao") {
                  _this.$layer.alert("提交成功", function () {
                    _this.$layer.closeAll();
                  });
                } else {
                  _this.$layer.alert("保存成功", function () {
                    _this.$layer.closeAll();
                  });
                }
              } else {
                _this.$layer.alert(res.msg);
                _this.$layer.closeAll();
              }
            })
            .catch(() => {})
            .finally(() => {});
        }
        _this.messageDialog = false;
        _this.applyMessage = false;
        _this.showPostApply = false;
      },
      addAns() {
        var randomNum = Math.round(Math.random() * 100 + 5);
        console.log("randomNum",randomNum);
        let _this = this
        _this.workExperienceList.push({
          id: randomNum,
          startEndTime: "",
          startTime: null,
          endTime: null,
          uintDept: "",
          post: "",
          duty: ""
        });
      },
      redAns(index) {
        let _this = this
        _this.workExperienceList.splice(index, 1);
      },
    },
  };
</script>
<style>
  .all-border {
    border: 1px solid #c1c5cd
  }
  .form-label .el-form-item__label {
    margin-top: 12px;
  }
  .form-label {
    display: flex;
    align-items: center;
  }
  .base-user-message {
    border: 1px solid #c1c5cd;
  }
  .el-dialog {
    height: 75vh;
    overflow: auto;
  }
  .el-dialog__header {
    display: flex;
    justify-content: center;
    font-weight: bold;
  }
  .form-col-left {
    border-bottom: 1px solid #c1c5cd;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .form-col {
    border-left: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .form-col-right {
    border-left: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-form-item {
    margin-bottom: 7px;
  }
  .form-input {
    margin-top: 7px;
    width: 180px;
  }
  .input-detailed-address {
    margin-top: 12px;
    width: 270px;
  }
  .form-col-tabel {
    align-items: center;
    line-height: 20px;
  }
  .form-input-unit {
    margin-top: 7px;
    width: 320px;
  }
  .form-input-post {
    margin-top: 7px;
    width: 290px;
  }
  .form-input-employer {
    width: 350px;
    margin-top: 7px;
  }
  .form-input-serial-number {
    width: 290px;
    margin-top: 7px;
  }
  .form-input-post-name {
    width: 330px;
    margin-top: 7px;
  }
  .form-input-two {
    widows: 190px;
    margin-top: 7px;
  }
  .form-input-birthplace {
    width: 200px;
    margin-top: 7px;
  }
  .form-input-native-place {
    width: 210px;
    margin-top: 7px;
  }
  .form-col-img {
    border: 1px solid #c1c5cd;
  }
  .user-img {
    width: 100%;
  }
  .form-col-hint {
    width: 100%;
    height: 30px;
    border-left: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    color: rgb(255, 0, 0);
    display: flex;
    justify-content: center;
    line-height: 30px;
  }
  .form-row-award {
    border-left: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
  }
  .form-row-award-left {
    margin-top: 7px;
    display: flex;
    justify-content: center;
  }
  .form-row-award-rigth {
    margin-top: 7px;
    width: 85%;
  }
  .form-row-else {
    border-left: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
  }
  .form-row-certificate {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #4070b3;
    border-top: 1px solid #c1c5cd;
    border-left: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
  }
  .certificate-message-title-left {
    text-align: center;
    font-weight: bold;
    border: 1px solid #c1c5cd;
  }
  .certificate-message-title {
    border-top: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    display: flex;
    justify-content: center;
  }
  .certificate-col {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #c1c5cd;
    border-left: 1px solid #c1c5cd;
  }
  .certificate-col-right {
    display: flex;
    justify-content: center;
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    border-left: 1px solid #c1c5cd;
  }
  .certificate-col-input {
    width: 90%;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .form-select-educationType {
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    border-left: 1px solid #c1c5cd;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .form-select-educationType-type {
    margin-top: 7px;
  }
  .form-select-max-educationType {
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .form-select-max-educationType-type {
    margin-top: 7px;
  }
  .education {
    width: 100%;
    height: 30px;
    font-weight: bold;
    line-height: 30px;
    display: flex;
  }
  .education-classify-left {
    border-left: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    text-align: center;
  }
  .education-classify {
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    text-align: center;
  }
  .full-time {
    height: 50px;
    line-height: 50px;
    display: flex;
  }
  .full-time-message {
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
  }
  .full-time-message-data {
    margin-top: 5px;
    width: 90%;
    margin-left: 2.3%;
  }
  .full-time-message-department {
    margin-top: 5px;
    width: 90%;
    margin-left: 5%;
  }
  .form-row-work-experience {
    text-align: center;
    color: #4070b3;
    height: 30px;
    line-height: 30px;
    border-left: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
  }
  .form-row-work {
    text-align: left;
    height: 40px;
    border-left: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
  }
  .work-experience-left {
    text-align: center;
    border-left: 1px solid #c1c5cd;
  }
  .work-experience-right {
    text-align: center;
    border-left: 1px solid #c1c5cd;
    border-right: 1px solid #c1c5cd;
  }
  .work-experience-col-date {
    border-top: 1px solid #c1c5cd;
    border-left: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .work-experience-col {
    border-top: 1px solid #c1c5cd;
    border-left: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
  }
  .work-experience-col-right {
    border: 1px solid #c1c5cd;
  }
  .work-experience-col-input {
    width: 90%;
    margin-left: 5%;
    margin-top: 16px;
    margin-bottom: 5px;
  }
  .work-experience-col-but {
    width: 60%;
    height: 100%;
    margin-left: 20%;
    margin-top: 16px;
    margin-bottom: 13px;
  }
  .work-experience-col-textarea {
    width: 90%;
    margin-left: 5%;
    margin-top: 7px;
  }
  .work-experience-col-data {
    width: 90%;
    margin-left: 2%;
    margin-top: 15px;
    margin-bottom: 6px;
  }
  .full-time-message-date {
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #c1c5cd;
    border-bottom: 1px solid #c1c5cd;
  }
</style>



// WEBPACK FOOTER //
// src/components/postApply.vue